import { useState, useEffect } from 'react';
import { getItemList, deleteItem } from 'helpers/backend_helper';
import { Common } from 'helpers/common';
import filterDataBySearch from 'Common/filterDataBySearch';

export const useItemList = () => {
    const [allItems, setAllItems] = useState<any[]>([]);
    const [itemList, setItemList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadItems(false);
    }, []);

    const loadItems = async (reload: boolean) => {
        try {
            if (itemList.length === 0 || reload) {
                const response = await getItemList();
                if (response) {
                    setItemList((response.data || response) as never[]);
                    setAllItems((response.data || response) as never[]);
                }
            }
        } catch (error) {
            console.error('Error loading items:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (itemId: number) => {
        try {
            await deleteItem(itemId);
            setItemList((prevList) => prevList.filter((item: any) => item.id !== itemId));
            uiHelper.showSuccessMessage("Item has been deleted successfully.");
            return true;
        } catch (error) {
            console.error('Error deleting item:', error);
            return false;
        }
    };

    const updateItemList = (result: any, isEdit: boolean, itemData: any) => {
        if (isEdit && itemData?.id) {
            setItemList((prevList) =>
                prevList.map((item: any) => (item.id === itemData.id ? { ...item, ...result.data || result } : item))
            );
        } else {
            setItemList((prevList) => [...prevList, result.data || result]);
        }
    };

    const filterSearchData = (searchText: string) => {
        if (searchText) {
            filterDataBySearch(allItems, searchText, ['item_code', 'item_name'], setItemList);
        } else {
            setItemList(allItems);
        }
    };

    return {
        itemList,
        isLoading,
        handleDelete,
        updateItemList,
        filterSearchData,
    };
};